/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Group_Name_PlaceholderInputs */

const en_team_manager_group_name_placeholder = /** @type {(inputs: Team_Manager_Group_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group Name`)
};

const fr_team_manager_group_name_placeholder = /** @type {(inputs: Team_Manager_Group_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du groupe`)
};

const de_team_manager_group_name_placeholder = /** @type {(inputs: Team_Manager_Group_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppenname`)
};

const it_team_manager_group_name_placeholder = /** @type {(inputs: Team_Manager_Group_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome del gruppo`)
};

const ru_team_manager_group_name_placeholder = /** @type {(inputs: Team_Manager_Group_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название группы`)
};

const es_team_manager_group_name_placeholder = /** @type {(inputs: Team_Manager_Group_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del grupo`)
};

const zh_cn2_team_manager_group_name_placeholder = /** @type {(inputs: Team_Manager_Group_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组名`)
};

const ja_team_manager_group_name_placeholder = /** @type {(inputs: Team_Manager_Group_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループ名`)
};

const hi_team_manager_group_name_placeholder = /** @type {(inputs: Team_Manager_Group_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह नाम`)
};

const pt_pt2_team_manager_group_name_placeholder = /** @type {(inputs: Team_Manager_Group_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do grupo`)
};

/**
* | output |
* | --- |
* | "Group Name" |
*
* @param {Team_Manager_Group_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_group_name_placeholder = /** @type {((inputs?: Team_Manager_Group_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Group_Name_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_group_name_placeholder(inputs)
	if (locale === "de") return de_team_manager_group_name_placeholder(inputs)
	if (locale === "it") return it_team_manager_group_name_placeholder(inputs)
	if (locale === "ru") return ru_team_manager_group_name_placeholder(inputs)
	if (locale === "es") return es_team_manager_group_name_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_group_name_placeholder(inputs)
	if (locale === "ja") return ja_team_manager_group_name_placeholder(inputs)
	if (locale === "hi") return hi_team_manager_group_name_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_group_name_placeholder(inputs)
	return en_team_manager_group_name_placeholder(inputs)
});